import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class DataTemplatesNameParser implements Parser {
	parse(
		schema: Record<
			string,
			Schema.Template | Schema.ListTemplate | Schema.PaginatedDataTemplate
		>,
	) {
		const names = Object.keys(schema)
			.map((name) => {
				if (schema[name].type.mode === "detail") {
					return `"${name}"`;
				}
				return "";
			})
			.filter(Boolean);

		return names.length
			? `export type DetailTemplates = ${names.join("|")}`
			: "";
	}
}
